import SectionHeader from "@/components/feature/SectionHeader";
import WorkCard from "@/components/feature/WorkCard";
import type { Work } from "@/types/work";

interface Props {
  title: string;
  subtitle?: string;
  moreLink: string;
  works: Work[];
  emptyText: string;
}

export default function LatestGrid({ title, subtitle, moreLink, works, emptyText }: Props) {
  return (
    <section>
      <SectionHeader title={title} subtitle={subtitle} moreLink={moreLink} />
      {works.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 bg-background-100/50 py-14 flex flex-col items-center gap-2 text-center">
          <i className="ri-inbox-2-line text-2xl text-foreground-400" />
          <p className="text-sm text-foreground-600">{emptyText}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {works.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      )}
    </section>
  );
}